import styles from './VerticalTabs.module.css';


export default function VerticalTabs({ tabs, activeTab, onChange, visible = true }) {
	if (!visible) return null;

	const handleClick = (id) => {
		onChange(activeTab === id ? false : id);
	};

	return (
		<div className={styles.rail}>
			{tabs.map((tab) => (
				<div
					key={tab.id}
					className={`${styles.tab} ${activeTab === tab.id ? styles.tab_active : ''}`}
					onClick={() => handleClick(tab.id)}
				>
					{tab.label}
				</div>
			))}
		</div>
	);
}

